import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import type { SpaceLineWidgetParams } from '@/types/chatbot.types';
import * as S from './widgets.styles';

const SpaceLineWidget: React.FC<SpaceLineWidgetParams> = observer(({ lines = 1, onAnimationComplete }) => {
  // Call completion immediately since this widget doesn't animate
  useEffect(() => {
    if (onAnimationComplete) {
      onAnimationComplete();
    }
  }, [onAnimationComplete]);

  return <S.SpaceLineContainer lines={lines} />;
});

SpaceLineWidget.displayName = 'SpaceLineWidget';

export default SpaceLineWidget;
